import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getPatientCaregiversRequest = (query, params) =>
  restRequest({
    uri: 'patientCaregivers',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const createPatientCaregiver = (body, params) =>
  restRequest({
    uri: 'patientCaregivers',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const updatePatientCaregiver = (body, params) =>
  restRequest({
    uri: `patientCaregivers/${body.id}`,
    method: HttpMethods.Patch,
    body,
    ...params,
  });

export const deletePatientCaregiver = (id, params) =>
  restRequest({
    uri: `patientCaregivers/${id}`,
    method: HttpMethods.Delete,
    ...params,
  });
